var React = require('react');

function MobileNavCross (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.956512 27.4731L28.6597 0.0396745L30.9682 2.32579L3.2651 29.7593L0.956512 27.4731Z","fill":"#001E50","key":0}),React.createElement("path",{"d":"M3.2623 0L30.9132 27.4999L28.609 29.7916L0.958062 2.29165L3.2623 0Z","fill":"#001E50","key":1})]);
}

MobileNavCross.defaultProps = {"width":"31","height":"30","viewBox":"0 0 31 30","fill":"none"};

module.exports = MobileNavCross;

MobileNavCross.default = MobileNavCross;
